import {
  List,
  Datagrid,
  TextField,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  SearchInput,
  FunctionField,
  required,
} from "react-admin";
import { Avatar, Box, Chip, Stack, Typography } from "@mui/material";

const newsFilters = [
  <SearchInput key="q" source="q" alwaysOn placeholder="Cerca news..." />,
];

const PublishedChip = (record) => {
  const ok = !!record?.is_published;
  return (
    <Chip
      size="small"
      label={ok ? "Pubblicata" : "Bozza"}
      variant={ok ? "filled" : "outlined"}
    />
  );
};

const NewsTitleCell = (record) => {
  const title = record?.title || "";
  const image = record?.image_url || "";

  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Avatar
        src={image || undefined}
        alt={title}
        variant="rounded"
        sx={{ width: 44, height: 44, bgcolor: "action.hover" }}
      >
        📰
      </Avatar>

      <Box sx={{ minWidth: 0 }}>
        <Typography fontWeight={800} noWrap>
          {title}
        </Typography>
        <Typography variant="caption" color="text.secondary" noWrap>
          {image ? "immagine impostata" : "nessuna immagine"}
        </Typography>
      </Box>
    </Stack>
  );
};

export const NewsList = () => (
  <List
    filters={newsFilters}
    perPage={25}
    sort={{ field: "id", order: "DESC" }}
    sx={{ "& .RaList-content": { marginTop: 1 } }}
  >
    <Datagrid
      rowClick="edit"
      bulkActionButtons={false}
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        "& .RaDatagrid-headerCell": { fontWeight: 800 },
        "& .RaDatagrid-rowCell": { py: 1.25 },
      }}
    >
      <TextField source="id" label="ID" />
      <FunctionField label="Titolo" render={(record) => NewsTitleCell(record)} />
      <FunctionField label="Stato" render={(record) => PublishedChip(record)} />
      {/* se ti dà fastidio, puoi anche togliere questa colonna */}
      <TextField source="image_url" label="Image URL" />
    </Datagrid>
  </List>
);

const NewsForm = () => (
  <SimpleForm>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "2fr 1fr" },
        gap: 2,
        alignItems: "start",
      }}
    >
      {/* Colonna sinistra */}
      <Box sx={{ display: "grid", gap: 2 }}>
        <TextInput source="title" label="Titolo" validate={[required()]} fullWidth />

        <TextInput
          source="body"
          label="Testo"
          multiline
          minRows={8}
          fullWidth
        />

        <BooleanInput source="is_published" label="Pubblica" />
      </Box>

      {/* Colonna destra */}
      <Box sx={{ display: "grid", gap: 2 }}>
        <TextInput
          source="image_url"
          label="Immagine (URL)"
          fullWidth
          helperText="URL diretto a png/jpg/webp"
        />

        {/* Preview immagine + stato */}
        <FunctionField
          label="Anteprima"
          render={(record) => {
            const title = record?.title || "News";
            const image = record?.image_url || "";
            const pub = !!record?.is_published;

            return (
              <Box
                sx={{
                  borderRadius: 4,
                  border: "1px solid",
                  borderColor: "divider",
                  p: 2,
                }}
              >
                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                  <Chip
                    size="small"
                    label={pub ? "Pubblicata" : "Bozza"}
                    variant={pub ? "filled" : "outlined"}
                  />
                </Stack>

                <Avatar
                  src={image || undefined}
                  alt={title}
                  variant="rounded"
                  sx={{
                    width: "100%",
                    height: 180,
                    bgcolor: "action.hover",
                    borderRadius: 3,
                  }}
                >
                  📰
                </Avatar>

                <Typography fontWeight={800} sx={{ mt: 1 }} noWrap>
                  {title}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {image ? "Immagine caricata" : "Nessuna immagine"}
                </Typography>
              </Box>
            );
          }}
        />
      </Box>
    </Box>
  </SimpleForm>
);

export const NewsEdit = () => (
  <Edit title="Modifica news">
    <NewsForm />
  </Edit>
);

export const NewsCreate = () => (
  <Create title="Nuova news">
    <NewsForm />
  </Create>
);
